import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { colors } from 'settings/colors'

export const BackIcon = () => {
  return <FontAwesomeIcon icon={faAngleLeft} size="xl" color={colors.grey800} />
}
